import { render, staticRenderFns } from "./MediaSlotList.vue?vue&type=template&id=78608b6c&scoped=true"
import script from "./MediaSlotList.vue?vue&type=script&lang=js"
export * from "./MediaSlotList.vue?vue&type=script&lang=js"
import style0 from "./MediaSlotList.vue?vue&type=style&index=0&id=78608b6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78608b6c",
  null
  
)

export default component.exports